// // guard-request-info
import SideMenu from '@/containers/side-menu/SideMenu.vue';
import GuardRequest from '@/pages/guard/guard-notifications/GuardNotifications';
import GuardCreateNotification from '@/pages/guard/create-notification/CreateNotification';

export default [
  {
    path: '/guard-notifications',
    name: 'GuardNotifications',
    components: {
      mainContent: GuardRequest,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'guard-notifications',
      },
      breadcrumb: {
        title: 'Notifcações da Guarda',
        paths: [{ title: 'Guarda Municipal' }],
      },
    },
  },
  {
    path: '/guard-create-notification',
    name: 'GuardCreateNotification',
    components: {
      mainContent: GuardCreateNotification,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'guard-notifications',
      },
      breadcrumb: {
        title: 'Criar Notifcações da Guarda',
        paths: [{ title: 'Guarda Municipal' }],
      },
    },
  }
];
